import { Component } from '@angular/core';
import { AuthService, UserTenantInfo } from '../../shared/services/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent {
  email = '';
  loading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  tenants: UserTenantInfo[] = [];
  showTenantSelection = false;
  selectedTenantId: number | null | undefined = null;
  emailSubmitted = false;

  constructor(private authService: AuthService, private router: Router) {}

  async onSubmit(event: Event) {
    event.preventDefault();
    this.loading = true;
    this.errorMessage = null;
    this.successMessage = null;
    this.tenants = [];
    this.showTenantSelection = false;

    try {
// $&
      const response = await this.authService.requestPasswordReset(this.email).toPromise();
// $&

      if (response && Array.isArray(response) && response.length > 0) {
        this.tenants = response;
        this.showTenantSelection = true;
        this.emailSubmitted = true;
// $&
      } else {
// $&
        this.successMessage = 'If an account exists with this email, password reset instructions will be sent.';
      }
    } catch (error: any) {
      // Show error message in console but don't reveal to user
// $&
      // Show generic message to prevent email enumeration
      this.successMessage = 'If an account exists with this email, password reset instructions will be sent.';
    } finally {
      this.loading = false;
    }
  }

  async onTenantSelect() {
    if (this.selectedTenantId === null || this.selectedTenantId === undefined) return;

    this.loading = true;
    this.errorMessage = null;
    this.successMessage = null;

    try {
      await this.authService.generatePasswordResetToken(this.email, this.selectedTenantId).toPromise();
      this.successMessage = 'Password reset instructions have been sent to your email.';
      this.showTenantSelection = false;
      this.tenants = [];
      this.selectedTenantId = null;
    } catch (error: any) {
      this.errorMessage = 'Failed to send reset instructions. Please try again.';
// $&
    } finally {
      this.loading = false;
    }
  }

  goBack() {
    this.showTenantSelection = false;
    this.emailSubmitted = false;
    this.tenants = [];
    this.selectedTenantId = null;
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
